import { z } from "zod";

export const mcpConsentDecisionRequestSchema = z.object({
  request_id: z.string().regex(/^[A-Za-z0-9_-]{43}$/),
  approve: z.boolean(),
});

export type McpConsentDecisionRequest = z.infer<typeof mcpConsentDecisionRequestSchema>;
